import { Box, RadioImage } from '@origin-digital/style-guide';
import * as React from 'react';
import analytics from '../../../../analytics';
import FieldError from '../FieldError';
import { RadioGroupGrid } from '../../../RadioGroupGrid';
import { ClickableLink } from '../../../Link';

export type RadioImageGroupFieldProps = {
  name: string;
  options: { [option: string]: any }[];
  maxOptionsToShow?: number;
  onFieldChange?: (fieldName: string, value: string) => void;
  isValid?: boolean;
  touched?: boolean;
  arrayHelpers:
    | {
        [key: string]: {
          [key: string]: string | string[] | undefined;
        };
      }
    | any;
};

export type RadioImageGroupFieldState = {
  showAllOptions: boolean;
};

function getOptionsToShow(
  options: { [option: string]: any }[],
  maxOptionsToShow: number,
  showAllOptions: boolean
): { [option: string]: any }[] {
  if (options.length <= maxOptionsToShow || showAllOptions === true) {
    return options;
  }
  return options.slice(0, maxOptionsToShow);
}

export class RadioImageGroupField extends React.Component<RadioImageGroupFieldProps, RadioImageGroupFieldState> {
  constructor(props: RadioImageGroupFieldProps) {
    super(props);

    this.onSelect = this.onSelect.bind(this);
    this.toggleShowAllOptions = this.toggleShowAllOptions.bind(this);

    this.state = {
      showAllOptions: false
    };
  }

  componentWillMount() {
    const { arrayHelpers, options } = this.props;
    const visibleOptions = options.slice(0, 4);
    const visibleOptionLabels = visibleOptions.map(i =>
      i.label
        .replace(/ /g, '_')
        .replace(/-/g, '')
        .toUpperCase()
    );

    if (
      arrayHelpers.form.values.roofType !== undefined &&
      !visibleOptionLabels.includes(arrayHelpers.form.values.roofType)
    ) {
      this.setState({
        showAllOptions: true
      });
    }
  }

  onSelect(value: string) {
    const { arrayHelpers, name, onFieldChange } = this.props;

    if (!arrayHelpers.form.values[name]) {
      arrayHelpers.form.values[name] = [];
    }

    if (arrayHelpers.form.values[name][0] !== value) {
      if (onFieldChange) {
        onFieldChange(name, value);
      }

      arrayHelpers.push(value);
      arrayHelpers.form.setFieldValue(name, value, false);
      arrayHelpers.form.setFieldTouched(name, true, false);
    }

    analytics.radioSelect(name, value);
  }

  toggleShowAllOptions() {
    this.setState({
      showAllOptions: !this.state.showAllOptions
    });
  }

  render() {
    const { arrayHelpers, name, options, isValid, maxOptionsToShow = 4 } = this.props;
    const { showAllOptions } = this.state;
    const hasError = arrayHelpers.form.errors[name] || false;
    const value = arrayHelpers.form.values[name];
    const optionsToShow = getOptionsToShow(options, maxOptionsToShow, showAllOptions);
    const canHideItems = options.length > maxOptionsToShow;

    return (
      <React.Fragment>
        <RadioGroupGrid name={name} onChange={e => this.onSelect(e.value)} value={value}>
          {optionsToShow.map((o, i) => (
            <RadioImage key={i} name={o.value} label={o.label} src={o.src} />
          ))}
        </RadioGroupGrid>

        {canHideItems ? (
          <Box marginBottom={4}>
            <ClickableLink
              text={showAllOptions ? 'Show less' : 'Show more'}
              color="red"
              onClick={e => this.toggleShowAllOptions()}
            />
          </Box>
        ) : null}

        {hasError &&
          !isValid && (
            <Box marginLeft={3}>
              <FieldError name={name} error={name} />
            </Box>
          )}
      </React.Fragment>
    );
  }
}
